// extracted by mini-css-extract-plugin
export default {"paper":"BaseTable_paper__9Kj-K","baseSubTable":"BaseTable_baseSubTable__Mepod","baseTable":"BaseTable_baseTable__e34OL"};